module.exports = __webpack_public_path__ + "img/table-active.121862b7.svg";